import React from "react";
import { useLoaderData } from "react-router-dom";
import { FaGithub, FaLink, FaCheckSquare } from "react-icons/fa";
import { PhotoProvider, PhotoView } from "react-photo-view";

const ProjectDetails = () => {
  const project = useLoaderData();
  const {
    name,
    liveSite,
    githubClient,
    githubServer,
    description,
    images,
    category,
    technologies,
    features,
  } = project;

  console.log(project);

  return (
    <section id="projectDetails" className="bg-main text-white">
      <div className="container flex flex-col justify-center p-6 mx-auto py-12 lg:flex-row lg:justify-between">
        <div className="flex flex-col justify-center  text-center rounded-sm lg:w-1/2 lg:text-left">
          <h2 className="text-4xl font-bold tracking-widest">{name}</h2>
          <p className="text-sm text-secondary mb-3">{category}</p>
          <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
            <a
              rel="noopener noreferrer"
              href={githubClient}
              target="_blank"
              className="bg-secondary rounded-xl px-2 hover:bg-transparent border border-secondary transition-all duration-500 flex justify-center items-center"
            >
              <FaGithub /> <span className="ml-1">Client Code</span>
            </a>
            <a
              rel="noopener noreferrer"
              href={githubServer}
              target="_blank"
              className="bg-secondary rounded-xl px-2 hover:bg-transparent border border-secondary transition-all duration-500 flex justify-center items-center"
            >
              <FaGithub /> <span className="ml-1">Server Code</span>
            </a>
            <a
              rel="noopener noreferrer"
              href={liveSite}
              target="_blank"
              className="bg-secondary rounded-xl px-2 hover:bg-transparent border border-secondary transition-all duration-500 flex justify-center items-center"
            >
              <FaLink /> <span className="ml-1">Live Site</span>
            </a>
          </div>
          <p className="mt-4 mb-2 text-base leading-5">{description}</p>

          <h2 className="text-2xl font-semibold tracking-widest">
            Technologies
          </h2>
          <ul className="flex flex-wrap gap-2 pt-2">
            {technologies.map((tech, i) => (
              <li
                key={i}
                className="text-xs leading-3 border bg-transparent px-2 py-1 rounded-md cardBtn"
              >
                {tech}
              </li>
            ))}
          </ul>
          <h2 className="text-2xl font-semibold tracking-widest mt-6">
            Features
          </h2>
          <ul className="p-3">
            {features.map((feature, i) => (
              <li key={i} className="text-stone2 flex items-center gap-2">
                <FaCheckSquare className="text-secondary" /> {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="container mx-auto px-6">
        <h2 className="text-2xl font-semibold tracking-widest">
          Preview Screenshot
        </h2>
        <div className=" py-4 ">
          <PhotoProvider>
            <div className="flex flex-wrap items-center gap-2">
              {images.map((item, index) => (
                <PhotoView key={index} src={item}>
                  <img
                    src={item}
                    alt=""
                    className="object-cover object-center h-72 "
                  />
                </PhotoView>
              ))}
            </div>
          </PhotoProvider>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetails;
